import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { OrderActionTypes } from './types'
import { listSuccess, listError, updateSuccess, updateError, createSuccess, createError, deleteSuccess, deleteError } from './actions'
import { GeneralUtil } from '../../utils/generalUtil';
import { Table } from '../interface'

const generalUtil: GeneralUtil = new GeneralUtil();

const getRecords = async (searchParams: any) => {
  searchParams.table = Table.Order;
  return await generalUtil.GetList(searchParams);
}
const createRecord = async (doc: any) => {
  doc.table = Table.Order; 
  return await generalUtil.Create(doc);
}
const updateRecord = async (keyValues: any) => {
  keyValues.table = Table.Order; 
  return await generalUtil.Update(keyValues);
}
const deleteRecord = async (id:string) => {
  return await generalUtil.Delete(id, Table.Order);
}

function* handleList(action: any) {
  try {
    const res = yield call(getRecords, action.payload);
    if (res.isSuccess) {
      yield put(listSuccess(res))
    } else {
      yield put(listError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(listError(err.stack))
    } else {
      yield put(listError('An unknown error occured.'))
    }
  }
}

function* handleCreate(action: any) {
  try {
    const res = yield call(createRecord, action.payload);
    if (res.isSuccess) {
      yield put(createSuccess(res.doc))
    } else {
      yield put(createError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(createError(err.stack))
    } else {
      yield put(createError('An unknown error occured.'))
    }
  }
}

function* handleUpdate(action: any) {
  try {
    const res = yield call(updateRecord, action.payload);
    if (res.isSuccess) {
      yield put(updateSuccess(res.doc))
    } else {
      yield put(updateError({"errors": res.errors, "isConflict": res.isConflict}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(updateError(err.stack))
    } else {
      yield put(updateError('An unknown error occured.'))
    }
  }
}

function* handleDelete(action: any) {
  try {
    const res = yield call(deleteRecord, action.payload.id);
    if (res.isSuccess) {
      yield put(deleteSuccess(res.doc.id)); // Return delete
    } else {
      yield put(deleteError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(deleteError(err.stack))
    } else {
      yield put(deleteError('An unknown error occured.'))
    }
  }
}

function* watchListRequest() {
  yield takeEvery(OrderActionTypes.LIST_REQUEST, handleList)
}

function* watchCreateRequest() {
  yield takeEvery(OrderActionTypes.CREATE_REQUEST, handleCreate)
}

function* watchUpdateRequest() {
  yield takeEvery(OrderActionTypes.UPDATE_REQUEST, handleUpdate)
}

function* watchDeleteRequest() {
  yield takeEvery(OrderActionTypes.DELETE_REQUEST, handleDelete)
}

function* OrdersSaga() {
  yield all([
    fork(watchListRequest), 
    fork(watchUpdateRequest), 
    fork(watchCreateRequest), 
    fork(watchDeleteRequest)
  ]);
}

export default OrdersSaga
